package pl.mothdigital.neuronowi.components.widgets

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.navigation.*
import com.varabyte.kobweb.silk.style.*
import com.varabyte.kobweb.silk.style.breakpoint.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import pl.mothdigital.neuronowi.theme.*
import pl.mothdigital.neuronowi.theme.text.*

val NavItemTextStyle = TextBaseStyle.extendedBy {
    base { Modifier.fontSize((0.85).cssRem).lineHeight(1.5.cssRem) }
    Breakpoint.MD {
        Modifier.fontSize((1).cssRem).lineHeight(1.5.cssRem)
    }
    Breakpoint.SM {
        Modifier.fontSize((0.85).cssRem).lineHeight(1.5.cssRem)
    }
    Breakpoint.MD {
        Modifier.fontSize((0.85).cssRem).lineHeight(1.5.cssRem)
    }
    Breakpoint.LG {
        Modifier.fontSize((1).cssRem).lineHeight(1.5.cssRem)
    }
    Breakpoint.XL {
        Modifier.fontSize((1).cssRem).lineHeight(1.5.cssRem)
    }
}


@Composable
fun NavItem(text: String, route: String, isRoute: Boolean) {
    var isHovered by remember { mutableStateOf(isRoute) }

    Column {
        Link(
            path = route,
            modifier = NavItemTextStyle.toModifier()
                .onMouseEnter { isHovered = true }
                .onMouseLeave { if (isRoute.not()) isHovered = false }
                .color(if (isHovered) SiteTheme.green._600 else SiteTheme.black._900)
                .padding(leftRight = 8.px),
            variant = UndecoratedLinkVariant.then(UncoloredLinkVariant)
        ) {
            Text(text)
        }
        Box(modifier = Modifier.height(4.px))
        Box(
            modifier = Modifier
                .width(if (isHovered) 100.percent else 0.percent)
                .height(2.px)
                .backgroundColor(if (isHovered) SiteTheme.green._600 else SiteTheme.black._900)
                .transition(Transition.of("width", 0.3.s, AnimationTimingFunction.EaseInOut))
                .bottom(0.px)
        )
    }
}
